export const searchParamsToObject = (searchParams, defaultFilters) => {
  const params = {};
  let paramsCounter = 0;
  for (const key of Object.keys(defaultFilters)) {
    params[key] = defaultFilters[key];
    if (searchParams.has(key)) {
      if (Array.isArray(defaultFilters[key])) {
        params[key] = searchParams.getAll(key);
        paramsCounter += params[key].length;
      } else {
        switch (typeof defaultFilters[key]) {
          case "number":
            params[key] = Number(searchParams.get(key));
            break;
          case "string":
            params[key] = searchParams.get(key);
            break;
          case "boolean":
            params[key] = searchParams.get(key) === "true";
            break;
        }
        paramsCounter += defaultFilters[key] !== params[key] ? 1 : 0;
      }
    }
  }
  return [params, paramsCounter];
};
